// extracted by mini-css-extract-plugin
export default {"container":"register_container__US4mv","wrapper":"register_wrapper__WxbrE","link":"register_link__cBNFt","span":"register_span__15AX8"};